import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface ReferrerAnnualPlanCostPerMonthState {
  referrerCostPerMonth: number | null;
}

interface ReferrerCreditOutput {
  cost: string | null;
}

const referrerAnnualPlanCostPerMonth: Module<ReferrerAnnualPlanCostPerMonthState, RootState> = {
  namespaced: true,
  state: {
    referrerCostPerMonth: null,
  },
  mutations: {
    setValue(state: ReferrerAnnualPlanCostPerMonthState, value: ReferrerCreditOutput): void {
      state.referrerCostPerMonth = Number(value.cost);
    },
  },
  actions: {},
};

export default referrerAnnualPlanCostPerMonth;
